module.exports = __webpack_public_path__ + "static/media/location.69d85018.svg";